export class UpsertStudentSessionRequest {
    public id: string | null = null;
    public studentId: string = "";
    public sessionStatusId: string = "";
    public mentorId: string = "";
    public activityTypeId: string | null = null;
    public sessionDate: Date | null = new Date();
    public sessionStartTime: string | null = null;
    public sessionEndTime: string | null = null;
    public didAttend: boolean = false;
    public reportIncident: boolean = false;
    public isAdmin: boolean = false;
    public wellbeingId: string = "";
    public involvementId: string = "";
    public sessionPlan: string | null = null;
    public sessionFeedback: string | null = null;
    public sessionDocumentRequest: UpsertSessionDocumentRequest[] = [];
    public studentSessionAbsenceRequest: UpsertStudentSessionAbsenceRequest = new UpsertStudentSessionAbsenceRequest();
    public studentSessionTargetRequests: UpsertStudentSessionTargetRequest[] = [];
    public studentSessionSubTargetRequests: UpsertStudentSessionSubTargetRequest[] = [];
    public studentSessionAQACertificateRequests: UpsertStudentSessionAQACertificateRequest[] = [];
    public studentSessionBehaviourRequests: UpsertStudentSessionBehaviourRequest[] | null = null;
    // legacy business logic
    public subTargets: string = "";
    public mentoring: string = "";
}

export class UpsertStudentSessionSubTargetRequest {
    public id: string | null = null;
    public studentSubTargetId: string = "";
    public studentTargetId: string = "";
    public studentSessionTargetId: string | null = null;
    public sessionPlan: string | null = null;
    public detail: string | null = null;
    public mentoring: string | null = null;
    public score: number | null = null;
}

export class UpsertStudentSessionTargetRequest {
    public id: string | null = null;
    public studentTargetId: string = "";
    public studentSessionId: string | null = null;
}

export class UpsertStudentSessionAQACertificateRequest {
    public id: string | null = null;
    public studentSessionId: string | null = null;
    public description: string | null = null;
    public isDeleted: boolean = false;
}

export class UpsertSessionDocumentRequest {
    public id: string | null = null;
    public studentSessionId: string | null = null;
    public documentCategoryId: string = "";
    public fileName: string = "";
    public fileSize: string = "";
    public fileUrl: string = "";
    public isDeleted: boolean = false;
}

export class UpsertStudentSessionAbsenceRequest {
    public id: string | null = null;
    public studentSessionId: string | null = null;
    public absenseTypeId: string | null = null;
    public reason: string | null = null;
    public isDeleted: boolean = false;
}

export class UpsertStudentSessionBehaviourRequest {
    public id: string | null = null;
    public studentSessionId: string | null = null;
    public studentBehaviourId: string | null = null;
    public score: number = 0;
}
